import React from 'react';
import Paper from '@material-ui/core/Paper';
import urlBase from '../../../url-base';
import CircularProgress from '@material-ui/core/CircularProgress';
//import FloatingActionButton from 'material-ui/FloatingActionButton';
//import ContentAdd from 'material-ui/svg-icons/content/add';
import Dialog from 'material-ui/Dialog';
import Grid from '@material-ui/core/Grid';
import TextField from 'material-ui/TextField';
import axios from 'axios';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { Colors, Styles, tableStyles } from '../../../../src/styles/theme';
import RaisedButton from 'material-ui/RaisedButton';
import { Button} from 'reactstrap';

class BrokerList extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: 'loading',
      id: '',
      name: '',
      user :{
        id :''
      },
      email: '',
      active: '',
      password: '',
      image: '',
      responsible: '',
      tituloDialog: 'Novo',
      modalOpen: false,
      loadingSave: false,
      success: null,
      emailError: {
        display: 'none',
        msg: ''
      },
      errorMessage:'',

      showTable: false
    };
    this.userStatus = {
      true : 'ATIVO',
      false : 'INATIVO'
    }; 
    this.styles = {
      error: {
        textAlign: 'center',
        fontSize: 18,
        color:'#ea0000',
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      zero: {
        textAlign: 'center',
        fontSize: 18,
        background:'#fff',
        padding:10,
        borderRadius: 3,
        fontWeight: 500
      },
      titleTable: {
        textAlign: 'center',
        padding: 0
      },
      modal: {
        width: '85%',
        maxWidth: 'none',
      },
      closeBtn: {
        float: 'right',
        width: 25,
        cursor: 'pointer',
        position: 'relative',
        bottom: 15,
        left: 5
      },
      inputs: {
        marginLeft: 10,
      },
      sendFormSuccess: {
        padding: 10,
        color: '#155724',
        backgroundColor: '#d4edda',
        borderColor: '#c3e6cb'
      },
      sendFormError: {
        padding: 10,
        color: '#721c24',
        backgroundColor: '#f8d7da',
        borderColor: '#f5c6cb'
      }
    };

    // Campos obrigatórios
    this.errorField = {
      name: '',
      email: '',
      password: '',
      responsible: ''
    };

    this.errorFormat = {
      email: ''
    };
  }


  componentWillMount() {
    this.getData(urlBase.loopBack + 'Brokers?filter={"include":"user"}');
  }

  getData(url) {
    axios.get(url)
    .then((response) => {
      let state = this.state;

      if (response.data.length == 0)
        state.data = 'zero';
      else
        state.data = response.data;
      
      for (let i = 0; i < state.data.length; i++) {
        state.data[i].user.active = this.userStatus[state.data[i].user.active];
      }        
      if (state.showTable == false) {
        state.showTable = true;

        $(document).ready( function () {
          $('#table_id').DataTable({
            "language": {
              "url": urlBase.client + "assets/plugins/datatables/Portuguese-Brasil.lang"
            },
            "order": [[0, "asc"]],
            lengthMenu: [
              [10, 25, 50, 100, -1],
              ['10', '25', '50', 100, 'Todas']
            ]
          });
        });
      }

      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.data = 'error';
      this.setState(state);
    }.bind(this));
  }

  // Monitora mudanças a atualiza estados dos inputs text
  onChange(e) {
    let state = this.state;
    state[e.target.name] = e.target.value;

    if (e.target.value == '')
      this.errorField[e.target.name] = 'Campo obrigatório';
    else
      this.errorField[e.target.name] = '';

    this.setState(state);
  }

  onBlurField(e) {
    let state = this.state;
    state.emailError.display = 'none';
    state.emailError.msg = '';
    this.setState(state);

    if (e.target.type == 'email') {
      if (!e.target.validity.valid)
        this.errorFormat.email = 'Formato esperado: email@exemplo.com';
      else {
        this.onBlurEmail(e);
        this.errorFormat.email = '';
      }
    }
  }

  fileToBase64() {
    let reader = new FileReader();
    let file = document.getElementById('file_image').files[0];

    reader.onloadend = function() {
      document.getElementById('image_64').value = reader.result;
    }.bind(this);
    reader.readAsDataURL(file);
  }

  addBroker() {

    let erro = this.errorField;
    erro.name = '';
    erro.email = '';
    erro.password = '';

    this.setState(erro);
    this.stateDefault();
    let state = this.state;
    state.loadingSave = false;
    state.success = null;
    state.tituloDialog = 'Novo';
    state.modalOpen = true;
    this.setState(state);
  }

  saveBroker() {
    let isNewPassword = false;

    let state = this.state;
    state.loadingSave = true;
    this.setState(state);

    let dataPost = [];
    if (state.tituloDialog === 'Alterar') { 
      dataPost = {
        id: this.state.id,
          name: this.state.name,
           user :{
            id :this.state.user.id
          }, 
          email: this.state.email,
          active: this.state.active,

          password: this.state.password,
        //image: document.getElementById('image_64').value,
          image: '',

        responsible: this.state.responsible
      }

    } else {
      if (this.state.password == '')
         isNewPassword = true;

      dataPost = {
          name: this.state.name,
          email: this.state.email,
          password: this.state.password,
          active: this.state.active,
          //image: document.getElementById('image_64').value,
          image: '',
          responsible: this.state.responsible
      }

    }

    let url = urlBase.loopBack + '/Brokers/saveUserBroker';

    if (state.name.length != 0 &&
      state.email.length != 0 &&
      state.responsible.length != 0 &&
      !isNewPassword   ) {
     
      axios.post(url, dataPost)
      .then(() => {
        let state = this.state;
        state.loadingSave = false;
        state.success = true;
        this.setState(state);
        this.stateDefault();
        this.handleModalClose()
      })
    .catch(error => {
      // CAPTURA DO ERRO REAL
      let mensagemAmigavel = "Erro interno no servidor.";

      if (error.response && error.response.data) {
        // No Loopback, o erro costuma vir dentro de error.response.data.error.message
        const serverError = error.response.data.error;
        
        if (serverError && serverError.details) {
            // Se houver detalhes de validação (como o email duplicado)
            mensagemAmigavel = serverError.details.messages.email[0]; 
        } else {
            mensagemAmigavel = serverError.message || mensagemAmigavel;
        }
      }

      console.log("Erro detalhado do Back-end:", error.response.data);
        if (mensagemAmigavel.includes("Email already exists")) {
            this.errorFormat.email = "Este e-mail já está cadastrado.";
        }
      this.setState({ 
        success: false, 
        errorMessage: this.errorFormat.email, // Aqui vai o "Email already exists"
        loadingSave: false 
      });
    });
    /* APAGAR TRECHO ANTIGO    
      .catch(function (error) {
        let state = this.state;
        state.success = false;
        state.loadingSave = false;
        alert("Entrei no cath " + error.message)
        console.dir(" cath " + error)
        if (error.message.indexOf("422") != -1) {
          state.emailError.msg = "E-mail já em uso por outro usuário.";
        } else {
          state.errorMessage = error.message;
        }
        this.setState(state);
      }.bind(this));
      */
    }
    else {
      //alert('Necessário preencher os campos obrigatórios de forma correta.');
      let state = this.state;
      state.errorMessage = 'Necessário preencher os campos obrigatórios de forma correta.';
      state.emailError.msg = '';
      state.success = false;
      state.loadingSave = false;
      this.setState(this.state);

 }
  }

  stateDefault() {
    let state = this.state;
    state.id = '';
    state.name = '',
    state.email = '',
    state.password = '',
    state.image = '',
    state.responsible = '',
    state.emailError = {
      display: 'none',
      msg: ''
    };

    this.setState(state);
  }

  onBlurEmail(e) {
    if (e.target.value.length > 0) {
      let url = urlBase.loopBack + 'Accounts/count?where={"email":"'+e.target.value+'"}'+'&access_token='+localStorage.getItem('dental_t');

      axios.get(url)
      .then((response) => {
        let state = this.state;
        // Se encontrar pelo menos um vendedor ou mais com mesmo email
        if (response.data.count > 0) {
          state.emailError.display = 'block';
          state.emailError.msg = 'Email já em uso.';
        }
        else {
          state.emailError.display = 'none';
          state.emailError.msg = '';
        }
        this.setState(state);
      })
      .catch(function () {
        let state = this.state;
        state.emailError.display = 'block';
        state.emailError.msg = 'Erro ao verificar o email';
        this.setState(state);
      }.bind(this));
    }
  }
  
  handleModalClose() {
    this.setState({modalOpen: false});
    this.getData(urlBase.loopBack + 'Brokers?filter={"include":"user"}');
  }
  handleChange(e, _name, event, index, _value){
    let state = this.state;
    state.active = _value;
    this.setState(state); 
  }  
// Paulo
  edit(id) {

    axios.get(urlBase.loopBack + 'Brokers/'+id+'?filter={"include":"user"}').then((data) => {
      
      const broker = data.data;

      let erro = this.errorField;
      erro.name = '';
      erro.email = '';
      erro.password = '';

      this.setState(erro);

      let state = this.state;
      state.loadingSave = false;

      state.tituloDialog = 'Alterar';
      state.name = broker.user.name;
      state.email = broker.user.email;
      state.user.id = broker.user.id;
      state.active = broker.user.active;
      state.id = broker.id;
      state.responsible= broker.responsible;
      state.success = null;
      this.state.emailError.msg ='';

      state.modalOpen = true;
      this.setState(state);
    }); 
       
  }

render() {
  return (
    <div style={{ padding: '20px' }}>
      
        <style>{tableStyles}</style>

      {/* CABEÇALHO DA PÁGINA COM BOTÃO ADICIONAR */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        marginBottom: '20px',
        paddingLeft: '10px' 
      }}>
        <h2 style={{ 
          margin: 0, 
          fontSize: '1.4rem', 
          color: Colors.textDark, 
          fontWeight: 500,
          textTransform: 'uppercase' 
        }}>
          Gerenciar Corretoras
        </h2>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          style={{ ...Styles.buttonSuccess, textTransform: 'none', fontWeight: 'bold' }}
          onClick={this.addBroker.bind(this)}
        >
          Nova Corretora
      </Button>        

      </div>

      {
        this.state.data == 'loading' ? (
          <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <CircularProgress />
            <p>Carregando dados...</p>
          </div>
        ) : (
          this.state.data == 'error' ? (
            <p style={{ ...this.styles.error, textAlign: 'center' }}>
              Erro ao buscar dados das corretoras.
            </p>
          ) : (
            this.state.data == 'zero' ? (
              <div style={{ ...this.styles.zero, textAlign: 'center' }}>
                <p>Nenhuma corretora encontrada.</p>
                <RaisedButton 
                  label="Cadastrar Primeira Corretora" 
                  onClick={this.addBroker.bind(this)} 
                  secondary={true} 
                />
              </div>
            ) : (
              <div>
                <Paper style={{overflow: 'auto', marginLeft: 10, borderRadius:10 }}>
                    <table
                      id="table_id"
                      className="table-striped dataTable"
                      style={{ width: '100%' }} >
                    <thead>
                      <tr>
                        <th>Corretora</th>
                        <th>Responsável</th>
                        <th>E-mail</th>
                        <th>Status</th>
                        <th style={{ textAlign: 'center !important' }}>Ação</th>
                      </tr>
                    </thead>

                    <tbody>
                      {this.state.data.map((item, index) =>
                        <tr
                          key={index}
                          style={item.user.active == 'ATIVO' ? ({ padding: 0 }) : ({ padding: 0, color: 'rgb(244, 67, 54)' })}
                          className="row_table"
                        >
                          <td>{item.user.name}</td>
                          <td>{item.responsible}</td>
                          <td>{item.user.email}</td>
                          <td>
                            <span style={{
                              padding: '4px 8px',
                              borderRadius: '12px',
                              fontSize: '10px',
                              fontWeight: 'bold',
                              backgroundColor: item.user.active == 'ATIVO' ? Colors.statusAtivoBg : Colors.statusInativoBg,
                              color: item.user.active == 'ATIVO' ? Colors.statusAtivoText : Colors.statusInativoText
                            }}>
                              {item.user.active}
                            </span>
                          </td>

                          <td onClick={this.edit.bind(this, item.id)}
                            style={{ cursor: 'pointer', padding: 0, textAlign: 'center' }}>
                            <i className="fas fa-edit" style={{ color: Colors.primary }}></i>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>


                </Paper>
              </div>
            )
          )
        )
      }

      {/* O Dialog permanece o mesmo que refinamos anteriormente */}
         <Dialog
          title={
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '16px 24px',
              backgroundColor: Colors.backgroundLight,
              borderBottom: `1px solid ${Colors.borderLight}`,
              borderRadius: '8px 8px 0 0'
            }}>
              <span style={{ fontSize: '1.2rem', fontWeight: 600, color: Colors.textDark, textTransform: 'uppercase' }}>
                {this.state.tituloDialog} Corretora
              </span>
              <img
                style={{ cursor: 'pointer', width: '16px', opacity: 0.5 }}
                src={urlBase.client + '/assets/images/icons/icon_close.png'}
                onClick={this.handleModalClose.bind(this)}
              />
            </div>
          }
          titleStyle={{ padding: 0 }}
          bodyStyle={{ padding: '24px' }}
          modal={false}
          open={this.state.modalOpen}
          onRequestClose={this.handleModalClose.bind(this)}
          autoScrollBodyContent={true}
          contentStyle={{ width: '90%', maxWidth: '700px', borderRadius: '8px', overflow: 'hidden' }}
        >
          <div>
            {/* --- ALERTAS DE FEEDBACK --- */}
            {this.state.success != null && (
              <div style={{
                padding: '15px',
                borderRadius: '4px',
                marginBottom: '20px',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                backgroundColor: this.state.success ? Colors.statusAtivoBg : Colors.statusInativoBg,
                color: this.state.success ? Colors.statusAtivoText : Colors.statusInativoText,
                border: `1px solid ${this.state.success ? '#c8e6c9' : '#ffcdd2'}`
              }}>
                <i className={`fas ${this.state.success ? 'fa-check-circle' : 'fa-exclamation-circle'}`}></i>
                <span>
                  {this.state.success ? "Corretora salva com sucesso!" : this.state.errorMessage}
                </span>
              </div>
            )}

            {/* --- LOADING --- */}
            {this.state.loadingSave ? (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <CircularProgress size={50} color={Colors.primary} />
                <p style={{ marginTop: '15px', color: Colors.textMuted }}>Enviando dados...</p>
              </div>
            ) : (
              /* --- FORMULÁRIO --- */
              <div id="form">
                <Grid container spacing={16}>
                  <Grid item xs={12} sm={8}>
                    <TextField
                      errorText={this.errorField.name}
                      floatingLabelText="Nome da Corretora *"
                      name="name"
                      value={this.state.name}
                      fullWidth={true}
                      onChange={(e) => this.onChange(e)}
                      underlineFocusStyle={{ borderColor: Colors.primary }}
                      floatingLabelFocusStyle={{ color: Colors.primary }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <SelectField
                      floatingLabelText="Status *"
                      fullWidth={true}
                      value={this.state.active}
                      name="status"
                      onChange={this.handleChange.bind(this, null, 'status')}
                    >
                      <MenuItem value={true} primaryText={<span style={{ color: Colors.statusAtivoText }}>● ATIVO</span>} />
                      <MenuItem value={false} primaryText={<span style={{ color: Colors.statusInativoText }}>○ INATIVO</span>} />
                    </SelectField>
                  </Grid>

                  <Grid item xs={12} sm={7}>
                    <TextField
                      errorText={this.errorFormat.email}
                      floatingLabelText="E-mail *"
                      type="email"
                      name="email"
                      value={this.state.email}
                      fullWidth={true}
                      onChange={(e) => this.onChange(e)}
                      underlineFocusStyle={{ borderColor: Colors.primary }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={5}>
                    <TextField
                      errorText={this.errorField.password}
                      floatingLabelText="Senha *"
                      type="password"
                      name="password"
                      value={this.state.password}
                      fullWidth={true}
                      onChange={(e) => this.onChange(e)}
                      underlineFocusStyle={{ borderColor: Colors.primary }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <TextField
                      floatingLabelText="Nome do Responsável *"
                      value={this.state.responsible}
                      name="responsible"
                      fullWidth={true}
                      onChange={(e) => this.onChange(e)}
                      underlineFocusStyle={{ borderColor: Colors.primary }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <div style={{
                      marginTop: '15px',
                      padding: '20px',
                      border: `2px dashed ${Colors.borderLight}`,
                      borderRadius: '8px',
                      backgroundColor: Colors.backgroundLight,
                      textAlign: 'center'
                    }}>
                      <label style={Styles.label}>Logotipo da Corretora</label>
                      <input type="file" onChange={this.fileToBase64.bind(this)} style={{ fontSize: '12px', marginTop: '10px' }} />
                    </div>
                  </Grid>
                </Grid>

                {/* --- RODAPÉ DE AÇÕES --- */}
                <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                  <button
                    type="button"
                    onClick={this.handleModalClose.bind(this)}
                    style={{ 
                      ...Styles.buttonCancel, 
                      backgroundColor: Colors.textLight, // Usando cinza para cancelar
                      textTransform: 'none' 
                    }}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    onClick={this.saveBroker.bind(this)}
                    style={{ 
                      ...Styles.buttonSuccess, 
                      fontWeight: 'bold', 
                      textTransform: 'none' 
                    }}
                  >
                    Salvar Corretora
                  </button>
                </div>
              </div>
            )}
          </div>
        </Dialog>
    </div>
  );
}

}

export default BrokerList;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/Brokers/BrokerList.js
 **/